var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { faCircleCheck, faSquareInfo, faTriangleExclamation, faHexagonExclamation, } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, AlertTitle, Paper } from '@mui/material';
import { SnackbarContent, useSnackbar } from 'notistack';
import useStyles from './styles';
export var SnackbarSeverity;
(function (SnackbarSeverity) {
    SnackbarSeverity["Success"] = "success";
    SnackbarSeverity["Info"] = "info";
    SnackbarSeverity["Warning"] = "warning";
    SnackbarSeverity["Error"] = "error";
})(SnackbarSeverity || (SnackbarSeverity = {}));
const ExtensivSnackbar = React.forwardRef((_a, ref) => {
    var { id, icon = true, showTitle = false, title = 'Title', showAction = false, actionLabel = 'Action', closeable = true } = _a, props = __rest(_a, ["id", "icon", "showTitle", "title", "showAction", "actionLabel", "closeable"]);
    const { classes } = useStyles();
    const { closeSnackbar } = useSnackbar();
    return (_jsx(SnackbarContent, Object.assign({ ref: ref, "data-testid": `${props.severity}Notification`, style: { maxWidth: 470 } }, { children: _jsx(Paper, Object.assign({ elevation: 6 }, { children: _jsxs(Alert, Object.assign({ className: classes.MessageWrapper, iconMapping: {
                    success: _jsx(FontAwesomeIcon, { icon: faCircleCheck }),
                    info: _jsx(FontAwesomeIcon, { icon: faSquareInfo }),
                    warning: _jsx(FontAwesomeIcon, { icon: faTriangleExclamation }),
                    error: _jsx(FontAwesomeIcon, { icon: faHexagonExclamation }),
                } }, (closeable && {
                onClose: () => {
                    closeSnackbar(id);
                },
            }), (!icon && { icon: false }), { severity: props.severity, variant: 'filled', sx: { borderRadius: '4px' } }, { children: [showTitle && (_jsx(AlertTitle, { children: _jsxs("div", Object.assign({ className: classes.TitleAndActionLabelWrapper }, { children: [_jsx("div", { children: title }), showAction && _jsx("div", { children: actionLabel })] })) })), props.message] })) })) })));
});
export default ExtensivSnackbar;
//# sourceMappingURL=index.js.map